export const fileUpload = {
  actions: {
    updateImage({ commit }, data) {
      // field is for pages with more than one file upload
      const { file, field } = data;
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onloadend = () => {
          return commit('setImage', { uri: reader.result, field });
        };
      }
      return commit('setImage', { uri: undefined, field });
    },
  },
};
